import {create} from "zustand";
import {derivedRemoteStore} from "./DerivedStore";
import {EmployeeRef, KeyData, KeySnapshot} from "./Model";
import {getOrSet} from "../util/MapUtil";
import {emptyArray} from "../util/FunctionUtil";
import {useKeyDataStore} from "./KeyDataStore";
import {combineCmp, stringCmp} from "../util/SortUtil";

export class EmployeeKeyHistory {
    private readonly employeeHistory = new Map<EmployeeRef['id'], KeySnapshot[]>();
    private readonly employeeActiveRecords = new Map<EmployeeRef['id'], KeySnapshot[]>();

    constructor(keys: KeyData[]) {
        keys.forEach(key => {
            key.history.forEach(record => {
                const keySnapshot: KeySnapshot = {key, historyRecord: record};
                if (record.location.type === 'with-employee') {
                    getOrSet(this.employeeHistory, record.location.employee.id, emptyArray).push(keySnapshot);
                }
            });
        })

        for (const employeeKeyHistory of this.employeeHistory.values()) {
            employeeKeyHistory.sort(combineCmp(
                stringCmp(it => it.historyRecord.to ?? '9999-12-31'),
                stringCmp(it => it.historyRecord.from ?? ''),
                stringCmp(it => it.historyRecord.createdAt ?? ''),
            ));
        }

        this.employeeHistory.forEach((snapshots, employeeId) => {
            this.employeeActiveRecords.set(employeeId, snapshots.filter(snapshot => !snapshot.historyRecord.to));
        })
    }

    get(employee: EmployeeRef): KeySnapshot[] {
        return this.employeeHistory.get(employee.id) || [];
    }

    active(employee: EmployeeRef): KeySnapshot[] {
        return this.employeeActiveRecords.get(employee.id) || [];
    }
}

export const useEmployeeKeyHistoryStore = create(
    derivedRemoteStore(
        {keyData: useKeyDataStore},
        ({keyData}) => new EmployeeKeyHistory(keyData),
    )
);